const rankingItems = [
  { rank: 1, title: '某顶流男星深夜密会神秘女子，酒店监控视频曝光', heat: '98.7万', tag: '爆', tagColor: 'bg-primary-500' },
  { rank: 2, title: '知名互联网大厂内部裁员风波，高管连夜辞职引猜测', heat: '87.2万', tag: '热', tagColor: 'bg-accent-500' },
  { rank: 3, title: '某综艺节目录制现场冲突画面流出，导演组集体沉默', heat: '76.5万', tag: '新', tagColor: 'bg-secondary-500' },
  { rank: 4, title: '当红小花与前经纪公司解约内幕，千万违约金细节曝光', heat: '65.3万', heatT: '', tagColor: '' },
  { rank: 5, title: '某直播平台头部主播涉嫌虚假宣传，消费者集体维权', heat: '54.8万', heatT: '', tagColor: '' },
  { rank: 6, title: '娱乐圈知名夫妻婚变传闻升级，双方工作室均未回应', heat: '48.1万', heatT: '', tagColor: '' },
];

export default function Ranking() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="flex items-center gap-3 mb-10">
          <div className="w-1 h-7 bg-primary-500 rounded-full"></div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-100">
            吃瓜热度榜
          </h2>
          <span className="text-xs text-foreground-500 mt-1">实时更新 · TOP 6</span>
        </div>

        <div className="space-y-0">
          {rankingItems.map((item, idx) => (
            <a
              key={idx}
              href="#cards"
              className="flex items-center gap-4 px-4 py-4 hover:bg-background-200/60 transition-colors rounded-lg cursor-pointer group border-b border-background-200/50 last:border-b-0"
            >
              <div className={`w-8 h-8 flex items-center justify-center rounded-lg font-bold text-sm flex-shrink-0 ${
                item.rank === 1 ? 'bg-primary-500/20 text-primary-400' :
                item.rank === 2 ? 'bg-accent-500/20 text-accent-400' :
                item.rank === 3 ? 'bg-secondary-500/20 text-secondary-400' :
                'bg-background-200 text-foreground-500'
              }`}>
                {item.rank}
              </div>

              <div className="flex-1 min-w-0">
                <h3 className="text-sm md:text-base text-foreground-300 group-hover:text-primary-400 transition-colors truncate">
                  {item.title}
                </h3>
              </div>

              {item.tag && (
                <span className={`px-2 py-0.5 rounded text-xs text-white font-medium flex-shrink-0 ${item.tagColor}`}>
                  {item.tag}
                </span>
              )}

              <span className="text-xs text-foreground-600 flex-shrink-0 whitespace-nowrap w-16 text-right">
                {item.heat}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}